import { post, get } from './api';

export const getCoupon = function(params) {
    return get('/mycoupon/index', params);
};

export const setInvoiceAddress = function(params) {
    return post('/userAddress/setInvoiceAddress', params);
};

export const getInvoiceAddress = function() {
    return get('/userAddress/getInvoiceAddress');
};

export const setUserInvoice = function(params) {
    return post('/userInvoice/setUserInvoice', params);
};

export const getUserInvoice = function() {
    return get('/userInvoice/getUserInvoice');
};

export const getAddress = function(searchContent, page) {
    return get('/userAddress/list', { searchContent, page });
};

export const getDefaultAddress = function(addressType = 1) {
    return get('/userAddress/getDefaultAddress', { addressType });
};

export const addAddress = function(params) {
    return post('/userAddress/insert', params);
};

export const updateAddress = function(params) {
    return post('/userAddress/update', params);
};

export const deleteAddress = function(id) {
    return post('/userAddress/delete', { id });
};

export const resetPassword = function(newPassword, oldPassword) {
    return post('/user/resetPassword', { newPassword, oldPassword });
};

export const getUserInfo = function() {
    return get('/user/getUserInfo');
};

export const setUserInfo = function(params) {
    return post('/user/setUserInfo', params);
};

export const getUserBook = function(bookCode) {
    return get('/my/userbook/index', { bookCode });
};

export const getUserBookRecord = function(bookCode, page) {
    return get('/my/userbook/record/index', { bookCode, page });
};
